import { InjectionToken } from '@angular/core';

export const version = new InjectionToken<string>('version');

export class Injectables {
}
